// @flow
import apiRequest from '../../stores/ApiService';
import apiConfig from '../../config';

const getAccount = (baseApiUrl: string) =>
  apiRequest({
    method: 'GET',
    url: `${baseApiUrl}/${apiConfig.urls.accountConfiguration}`,
  }).then((response) => response.json());

export default {
  getAccount,
};
